export default __webpack_public_path__ + "static/media/gallery41.d97169a5.jpg";